import script from "./NotificationFormOrganisam.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationFormOrganisam.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationFormOrganisam.vue?vue&type=style&index=0&id=3ffba801&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ffba801"]])

export default __exports__